import { render, staticRenderFns } from "./Registrations.vue?vue&type=template&id=17b344ac"
import script from "./Registrations.vue.ts?vue&type=script&lang=ts&external"
export * from "./Registrations.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports